const resolveTicketDisplayAt = (ticket, searchMatch) => {
  return searchMatch?.displayAt || ticket?.lastMessageAt || ticket?.updatedAt || "";
};

export default resolveTicketDisplayAt;
